<div class="selector-container">
  <div *ngIf="isArcgisOn" class="selector-scroller">
    <div class="create-name">Válassza ki az arcgis attribútumot</div>
    <div class="create-select-container" *ngFor="let item of arcgisMapService.possibleAttributes">
      <div class="create-select-name">{{item.name}}</div>
      <div class="create-select" (click)="setArcgisAttr(item, att)" *ngFor="let att of item.fields">{{att.name}} | {{att.alias}}</div>
    </div>
  </div>
</div>

<div *ngIf="!isArcgisOn">
  <mat-form-field appearance="fill">
    <mat-label>Attribútum elnevezése</mat-label>
    <input matInput value="" [(ngModel)]="instance.name">
  </mat-form-field>
  <mat-form-field *ngIf="!isArcgis && !instance.isDate" appearance="fill">
    <mat-label>Új érték</mat-label>
    <input matInput value="" [(ngModel)]="currentVal">
  </mat-form-field>
  <div *ngIf="!isArcgis && !instance.isDate" class="add-button">
    <app-button
      (click)="addValue()"
      [title]="'Hozzáad'"
      [icon]="'post_add'"
    ></app-button>
  </div>
  <div *ngIf="isArcgis" class="add-button">
    <app-button
      (click)="isArcgisOn = true"
      [title]="'Attribútum hozzáadása'"
      [icon]="'post_add'"
    ></app-button>
  </div>
  <p *ngIf="!isArcgis && !instance.isDate">Lehetséges értékek:</p>
  <div *ngFor="let item of instance.possibleValues;" class="attributes">
    <div>{{item}}</div>
    <app-button
    (click)="deleteVal(item)"
    [icon]="'delete'"
    [customColor]="'red'"
    >Töröl</app-button>
  </div>
  <div *ngFor="let item of instance.ticketAttributeExtensions;" class="attributes">
    <div>{{item.externalLayer.url}} {{item.argisAttributeName}}</div>
    <app-button
    (click)="deleteVal(item)"
    [icon]="'delete'"
    [customColor]="'red'"
    >Töröl</app-button>
  </div>
  <mat-checkbox *ngIf="!isArcgis" class="checkbox-spacing" color='warn' [checked]="instance.multi" (change)="instance.multi = !instance.multi">Több válaszos</mat-checkbox>
  <mat-checkbox class="checkbox-spacing" [disabled]="instance.multi || isArcgis" color='warn' [checked]="instance.isDate" (change)="instance.isDate = !instance.isDate">Dátum</mat-checkbox>
  <mat-checkbox color='warn' class="checkbox-spacing" [checked]="instance.searchable" (change)="instance.searchable = !instance.searchable">Kereshető</mat-checkbox>
  <mat-checkbox *ngIf="isArcgis" color='warn' class="checkbox-spacing" [checked]="instance.isArcgis" (change)="instance.isArcgis = !instance.isArcgis">Kiemelt</mat-checkbox>
  <div class="save-button">
    <mat-checkbox *ngIf="!isArcgis" color='warn' [checked]="instance.otherEnabled === 0" (change)="setEnabled()">Kötelezően kitöltendő mező</mat-checkbox>
    <app-button
      (click)="save()"
      [title]="'Mentés'"
      [customColor]="'green'"
      [disabled]="instance.name.length === 0 || (instance.ticketAttributeExtensions.length === 0 && instance.possibleValues.length === 0)"
    ></app-button>
  </div>
</div>
